import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CardComponent } from '@vectronic/ui';
import { CDN_HOST } from '../cdn-host.injection';
import { ElasticBeltsDialogContentComponent } from './elastic-belts-dialog-content.component';

@Component({
  selector: 'vectronic-formly-one-housing-collar-elastic-belts-info',
  imports: [CardComponent, ElasticBeltsDialogContentComponent, MatTabGroup, MatTab],
  template: `
    <vectronic-card [title]="data.title" [displayClose]="true" (closed)="dialogRef.close()">
      <ng-container body>
        <div class="card-body">
          <div md-dialog-content class="content">
            <mat-tab-group animationDuration="0ms">
              <mat-tab label="Elastic Belt Option"
                ><vectronic-formly-elastic-belts-dialog-content [data]="elasticBeltOptions"
              /></mat-tab>
              <mat-tab label="Growing belt option"
                ><vectronic-formly-elastic-belts-dialog-content [data]="growingBeltOptions"
              /></mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </ng-container>
    </vectronic-card>
  `,
  styles: ``,
})
export class OneHousingCollarElasticBeltsInfoDialogComponent {
  data: { title: string } = inject(MAT_DIALOG_DATA);
  cdnHost = inject(CDN_HOST);
  dialogRef = inject(MatDialogRef<OneHousingCollarElasticBeltsInfoDialogComponent>);
  elasticBeltOptions = [
    {
      label: 'Type 1',
      favorite: true,
      description:
        'The elastic belt consists of the actual collar belt and an elastic element. The elastic belt material is 30 mm wide and has an elasticity of 90%. The outer protection is made from a Teflon tube.',
      elements: [
        {
          label: 'Drop-Shaped',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_elastic_type_1_drop-shaped.png`,
              alt: 'Type 1 Elastic Drop-Shaped',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_elastic_type_1_drop-shaped_detail.png`,
              alt: 'Type 1 Elastic Drop-Shaped Details',
            },
          ],
        },
        {
          label: 'Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_elastic_type_1_round.png`,
              alt: 'Type 1 Elastic Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_elastic_type_1_round_detail.png`,
              alt: 'Type 1 Elastic Round Shape Details',
            },
          ],
        },
      ],
    },
    {
      label: 'Type 2',
      favorite: false,
      description:
        'The elastic belt consists of the actual collar belt and an elastic element. The elastic belt material is 40 mm wide and has an elasticity of 80%. The outer protection is made from a Cordura tube.',
      elements: [
        {
          label: 'Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_elastic_type_2_round.png`,
              alt: 'Type 2 Elastic Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_elastic_type_2_round_detail.png`,
              alt: 'Type 2 Elastic Round Shape Details',
            },
          ],
        },
      ],
    },
  ];

  growingBeltOptions = [
    {
      label: 'Type 1',
      favorite: false,
      description:
        'The growing belt consists of the actual collar belt and an elastic element, covered with Cordura tubing. The elastic belt material is 40 mm wide and has an elasticity of 80%. The elastic material is layered and sewn. On tension, the seams open and the collar grows.',
      elements: [
        {
          label: 'Drop-Shaped',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_growing_type_1_drop-shaped.png`,
              alt: 'Type 1 Growing Drop-Shaped',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_growing_type_1_drop-shaped_detail.png`,
              alt: 'Type 1 Growing Drop-Shaped Details',
            },
          ],
        },
        {
          label: 'Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_growing_type_1_round.png`,
              alt: 'Type 1 Growing Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/one_housing_growing_type_1_round_detail.png`,
              alt: 'Type 1 Growing Round Shape Details',
            },
          ],
        },
      ],
    },
  ];
}
